import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

import { MessageService } from '../message.service';
import { Dialog } from '../../../models/dialog.model';
import { DialogEnum, OptionEnum } from '../messages.enum';
import {DialogOption} from "../../../models/dialog-option.model";

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class DialogComponent implements OnInit, OnDestroy {
  dialog: Dialog = new Dialog();
  isVisible = false;
  animationClass = '';
  
  public readonly OptionEnum = OptionEnum;
  public readonly DialogEnum = DialogEnum;
  
  private subscription?: Subscription;

  constructor(private readonly messageService: MessageService) {}

  ngOnInit(): void {
    this.subscription = this.messageService.startDialog().subscribe((dialog: Dialog) => {
      this.dialog = dialog;
      this.openDialog();
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private openDialog(): void {
    this.isVisible = true;
    this.animationClass = 'dialog--enter';
  }

  closeDialog(response: any): void {
    this.animationClass = 'dialog--exit';

    setTimeout(() => {
      this.isVisible = false;
      this.animationClass = '';
      this.dialog = new Dialog();
      this.messageService.sendDialogResponse(response);
    }, 200);
  }

  onResponse(option: DialogOption): void {
    this.closeDialog(option.value);
  }
}
